<markdown 
  class="markdown" 
  [class.is-inline]="isInline"
  [class.is-condensed]="isCondensed" 
  [class.is-half-condensed]="isHalfCondensed" 
  [data]="val" 
  ngPreserveWhitespaces
></markdown>